(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/native-app.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/native-app.js');
'use strict';

const DOCS_NATIVE = svs.selfExclusion.Constants.DOCS_NATIVE;
const NativeApp = () => React.createElement(React.Fragment, null, ' ', React.createElement("a", {
  className: "fc-sport-75",
  href: DOCS_NATIVE.PERSONAL_INFORMATION,
  rel: "noreferrer",
  target: "_blank"
}, "villkoren f\xF6r spelpaus"), ' ', "och bekr\xE4ftar att du tagit del av", ' ', React.createElement("a", {
  href: DOCS_NATIVE.PERSONAL_POLICY,
  rel: "noreferrer",
  target: "_blank"
}, "information om behandling av personuppgifter."));
svs.selfExclusion.components.NativeApp = NativeApp;

 })(window);